import { render, staticRenderFns } from "./garantias.captacao.vue?vue&type=template&id=35efa0f4&"
import script from "./garantias.captacao.vue?vue&type=script&lang=js&"
export * from "./garantias.captacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports